import { Action } from '@ngrx/store';
import { ProductsResponseOP, ProductOP, ProductOPReq } from '@cemex-core/cmx-api';

export enum AdtProductsActionTypes {
    FETCH_PRODUCTS = '[ADT Products] Fetch Products',
    LOAD_PRODUCTS_RESPONSE = '[ADT Products] Load Products Response',
    FETCH_PRODUCTS_FAILURE = '[ADT Products] Fetch Products Failure',
    LOAD_SELECTED_PRODUCT = '[ADT Products] Load Product Selected',
    UPDATE_PRODUCT = '[ADT Products] Update Product',
    RESET_PRODUCTS = '[ADT Products] Reset Products',
}

/**
 * Fetch admixture products
 */
export class FetchAdtProducts implements Action {
    readonly type: string = AdtProductsActionTypes.FETCH_PRODUCTS;

    constructor(public payload: ProductOPReq) {}
}

/**
 * Load admixture products response
 */
export class LoadProductsResponse implements Action {
    readonly type: string = AdtProductsActionTypes.LOAD_PRODUCTS_RESPONSE;
    constructor(public payload: ProductsResponseOP) {}
}

/**
 * Fetch admixture products failure
 */
export class FetchProductsFailure implements Action {
    readonly type: string = AdtProductsActionTypes.FETCH_PRODUCTS_FAILURE;
    constructor(public payload?: any) {}
}


/**
 * Load admixture product selected
 */
export class LoadProductSelected implements Action {
    readonly type: string = AdtProductsActionTypes.LOAD_SELECTED_PRODUCT;
    constructor(public payload: {[formId: string]: ProductOP}) {}
}

/**
 * Update admixture product
 */
export class AdtResetProducts implements Action {
    readonly type: string = AdtProductsActionTypes.RESET_PRODUCTS;
    constructor(public payload?: any) {}
}

export type ADTProductActions =
    | FetchAdtProducts
    | LoadProductsResponse
    | FetchProductsFailure
    | LoadProductSelected
    | AdtResetProducts;
